module.exports = __webpack_public_path__ + "img/liveIcon-blue.252dd7b0.svg";